import { Catalogo } from '@/types/types'
import Axios, { AxiosPromise } from 'axios'

export class CatalogoService {
  fectchAllRequest (): AxiosPromise<{data: Catalogo[]}> {
    return Axios.get('/catalogos')
  }
}
